<template>
  <div>Cancel</div>
</template>

<script>
export default {
  name: "DonateCancel",
  created() {
    window.location.href = "/";
  }
};
</script>

<style scoped></style>
